<template>
    <div class="view-container">
        <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="$t('DELETEBACKUP')">
            <delete-confirm @cancel="closeModal" @confirm="deleteBackupConfirm" :text="actionText"></delete-confirm>
        </modal>
        <Modal :title="$t('DownloadProgress')" :showDialog="activeModal == 'Progress'" @close="cancelDownload">
            <div class="progress-container vertical" style="min-width: 30vw;">
                <ProgressBar :loaded="bytesReceived" :total="bytesToReceive"/>
                <button class="cancel-button semi-bold" style="margin-top: 12px;" @click="cancelDownload">{{ $t('Cancel') }}</button>
            </div>
        </Modal>
        <div>
            <div class="max-grid">
                <ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="backups" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
                    <e-columns>
                        <e-column field='systemName' :headerText="$t('SystemName')" textAlign='Left' :filter="filterCheckBox" :customAttributes="customAttributes"></e-column>
                        <e-column field='createDate' :headerText="$t('CreateDate')" textAlign='Left' type="date" :format="dateTimeFormatOptions" :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                        <e-column field='receivedDate' :headerText="$t('ReceivedDate')" textAlign='Left' type="date" :format="dateTimeFormatOptions" :customAttributes="customAttributes" :filter="filterCheckBox"></e-column>
                        <e-column field='sizeText' :headerText="$t('FileSize')" textAlign='Left' :customAttributes="customAttributes"></e-column>
                        <e-column field='id' headerText="" width="150px" :allowSorting="false" :allowFiltering="false" :template="optionsTemplate"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import { getBackupsOverview, getBackupById, deleteBackup } from '@api';
import axios from 'axios';

import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';

import ProbablyOverflowingTextCell from '../components/Systems/ProbablyOverflowingTextCell.vue';
import Modal from '../components/Modal.vue';

import Vue from "vue";
import DeleteConfirm from '../components/DeleteConfirm.vue';
import ProgressBar from '../components/ProgressBar.vue';
import { parseProgress } from '../util/progress';

var context = null;

export default {
    components: {
        ProbablyOverflowingTextCell,
        Modal,
        DeleteConfirm,
        ProgressBar
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
            versions: [],
            // VIEW MANAGEMENT
            activeModal: null,
            activeData: null,
            selectedBackupId: null,
            actionText: null,
            // PROGRESS
            bytesReceived: 0,
            bytesToReceive: 0,
            downloadController: null,
            // GRID
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                'Search'
            ],
            wrapSettings: { wrapMode: 'Header' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckBox: {
                type: 'CheckBox',
            },
            customAttributes: { class: 'customcss' },
            backups: [],
            optionsTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div class="horizontal grow">
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('Download')" :content="$t('Download')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12" stroke="#346F8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </div>
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('DELETE')" content="${context.$t('Delete')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                            </div>
                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch(mode) {
                                    case 'Download':
                                        context.downloadBackup(this.data.id, this.data.fileName, this.data.fileSize);
                                        break;
                                    case 'DELETE':
                                        context.deleteVersion(this.data);
                                        break;
                                }
                            }
                        }
                    })
                }
            },
            TextTemplate: function () {
				return {
					template: {
						extends: ProbablyOverflowingTextCell,
					},
				};
			},
        }
    },
    methods: {
        async getData() {
            var backupsList = await getBackupsOverview();

            backupsList.forEach(element => {
                element.sizeText = element.fileSize.formatBytes(2)
            });

            this.backups = [...backupsList]
        },
        dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        openModal(data, modal) {
            this.activeModal = modal;
            this.activeData = data;
        },
        async closeModal(isGetData) {
            if (isGetData) {
                await this.getData();
            }

            this.actionText = null;
            this.selectedBackupId = null;

            this.openModal(null, null);
        },
        async deleteVersion(backup) {
            this.actionText = `Delete backup: ${backup.systemName} | ${backup.createDate}`
            this.activeModal = 'DELETE';
            this.selectedBackupId = backup.id;
        },
        async deleteBackupConfirm() {
            await deleteBackup(this.selectedBackupId);
            this.closeModal(true)
        },
        async downloadBackup(id, fileName, knownSize = 0) {
            this.activeModal = 'Progress';
            this.bytesReceived = 0;
            this.bytesToReceive = 0;
            this.downloadController = new AbortController();

            var followConfig = {
                signal: this.downloadController.signal,
                onDownloadProgress: progressEvent => {
                    const { loaded, total } = parseProgress(progressEvent, knownSize);
                    context.bytesReceived = loaded;
                    context.bytesToReceive = total;
                }
            };

            try {
                var blob = await getBackupById(id, followConfig);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob.data);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            } catch (e) {
                if (!axios.isCancel(e)) {
                    console.dir(e);
                }
            } finally {
                this.activeModal = null;
                this.downloadController = null;
            }
        },
        cancelDownload() {
            if (this.downloadController) {
                this.downloadController.abort();
            }
            this.activeModal = null;
        },
    },
    async mounted () {
        context = this;
        this.getData();
    },
}
</script>

<style scoped>
.progress-container {
    margin: 10px 20px;
}

#upload-progress {
    height: 20px;
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/BackupManagement.vue